import type { SimEvent } from '@/events/simEvents';

// Canonical Monday 04 May 2026 timeline. PRD §11 and §16 (12 scenarios).
// All times in +10:00 AEST.

export const SCRIPTED_EVENTS: SimEvent[] = [
  {
    id: 'sarah-missed-call',
    type: 'sarah-missed-call',
    scenarioId: 1,
    triggerIso: '2026-05-04T08:42:30+10:00',
    description: 'Sarah Holman 3:14am Sunday voicemail surfaces in the queue.',
  },
  {
    id: 'sarah-callback-ready',
    type: 'sarah-callback-ready',
    scenarioId: 1,
    triggerIso: '2026-05-04T09:14:00+10:00',
    description: 'Top-of-queue prompt: Sarah ready for callback.',
  },
  {
    id: 'sarah-call-answered',
    type: 'sarah-call-answered',
    scenarioId: 1,
    triggerIso: '2026-05-04T09:17:00+10:00',
    description: 'Outbound call connects. Sarah agrees to deposit.',
  },
  {
    id: 'sarah-stripe-deposit',
    type: 'sarah-stripe-deposit',
    scenarioId: 1,
    triggerIso: '2026-05-04T09:22:00+10:00',
    description: 'Stripe webhook: Sarah\'s deposit lands. Booking created at Coburg.',
  },
  {
    id: 'multi-studio-inbound',
    type: 'multi-studio-inbound',
    scenarioId: 12,
    triggerIso: '2026-05-04T13:00:00+10:00',
    description: 'Inbound to Frankston for a multi-studio agent.',
  },
  {
    id: 'pat-session-finish',
    type: 'pat-session-finish',
    scenarioId: 11,
    triggerIso: '2026-05-04T15:30:00+10:00',
    description: 'Pat finishes a session. In-chair rebooking modal available.',
  },
  {
    id: 'confirmations-queue-4pm',
    type: 'confirmations-queue-4pm',
    scenarioId: 7,
    triggerIso: '2026-05-04T16:00:00+10:00',
    description: '23 AI voice confirmation calls scheduled for tomorrow.',
  },
  {
    id: 'eod-metrics',
    type: 'eod-metrics',
    triggerIso: '2026-05-04T17:00:00+10:00',
    description: 'End-of-day metrics roll up.',
  },
  {
    id: 'daniel-future-readiness-fires',
    type: 'daniel-future-readiness-fires',
    scenarioId: 8,
    triggerIso: '2026-05-15T09:30:00+10:00',
    description: 'Six months later: Daniel\'s May trigger fires.',
  },
  {
    id: 'walk-in-arrives',
    type: 'walk-in-arrives',
    triggerIso: '2026-05-04T11:45:00+10:00',
    description: 'Walk-in at Coburg captured by apprentice on Front Desk.',
  },
];
